import BuilderWarningInfo from './BuilderWarningInfo';

export default BuilderWarningInfo;
